"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.google_protobuf = exports.telem_metadata = exports.openadr = exports.charger = exports.telem_svc = exports.events_svc = exports.big_file_svc = exports.charger_ui = exports.charging_session_attempt = exports.money = void 0;
exports.money = __importStar(require("./gen/protos/money"));
exports.charging_session_attempt = __importStar(require("./gen/protos/charging-session-attempt"));
exports.charger_ui = __importStar(require("./gen/protos/charger-ui-interface"));
exports.big_file_svc = __importStar(require("./gen/protos/big-file-svc"));
exports.events_svc = __importStar(require("./gen/protos/powernode-events-svc"));
exports.telem_svc = __importStar(require("./gen/protos/powernode-telem-svc"));
exports.charger = __importStar(require("./gen/protos/charger"));
exports.openadr = __importStar(require("./gen/protos/openadr-svc"));
exports.telem_metadata = __importStar(require("./gen/protos/telem-metadata"));
exports.google_protobuf = __importStar(require("./gen/google/protobuf/timestamp"));
